import { NgModule } from '@angular/core';
import { SimpleMatTooltipComponent } from "./simple-mat-tooltip.component";
import {  MatTooltipModule } from "@angular/material/tooltip";

@NgModule({
    imports: [MatTooltipModule],
    declarations: [SimpleMatTooltipComponent],
    exports: [SimpleMatTooltipComponent]
})
export class SimpleMatTooltipModule {}
